import { useEffect, useRef } from 'react'
import type { HistoryItem } from '../../types/terminal'
import { TerminalLine } from './TerminalLine'
import { TerminalInput } from './TerminalInput'
import styles from './TerminalBody.module.css'

interface TerminalBodyProps {
  history: HistoryItem[]
  input: string
  setInput: (value: string) => void
  commandHistory: string[]
  historyIndex: number
  setHistoryIndex: (index: number) => void
  onCommand: (cmd: string) => void
}

export function TerminalBody({
  history,
  input,
  setInput,
  commandHistory,
  historyIndex,
  setHistoryIndex,
  onCommand,
}: TerminalBodyProps) {
  const terminalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight
    }
  }, [history])

  return (
    <div className={styles.body} ref={terminalRef}>
      {history.map((item, index) => (
        <TerminalLine key={index} item={item} />
      ))}
      <TerminalInput
        input={input}
        setInput={setInput}
        commandHistory={commandHistory}
        historyIndex={historyIndex}
        setHistoryIndex={setHistoryIndex}
        onCommand={onCommand}
      />
    </div>
  )
}

